import { ReactNode } from 'react';
import styled from 'styled-components';

import { Drawer } from '@sorare/core/src/atoms/layout/Drawer';
import Dialog from '@sorare/core/src/components/dialog';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';

const StyledDialog = styled(Dialog)`
  background-color: var(--c-neutral-100);
`;
const StyledDrawer = styled(Drawer)`
  width: 480px;
  background: var(--c-neutral-100);
  padding-top: var(--triple-unit);
  border-left: 1px solid var(--c-neutral-200);
`;

type Props = {
  open: boolean;
  onClose: () => void;
  dialogTitle?: ReactNode;
  blurDrawerBackground?: boolean;
  children: ReactNode;
};
export const DrawerOrDialog = ({
  open,
  onClose,
  dialogTitle,
  blurDrawerBackground,
  children,
}: Props) => {
  const isDesktopAndAbove = useIsDesktopAndAbove();

  if (isDesktopAndAbove) {
    return (
      <StyledDrawer
        open={open}
        onBackdropClick={onClose}
        blur={blurDrawerBackground}
      >
        {children}
      </StyledDrawer>
    );
  }

  return (
    <StyledDialog onClose={onClose} open={open} title={dialogTitle}>
      {children}
    </StyledDialog>
  );
};
